"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateLocale = exports.getBaseLocale = void 0;
exports.getLocaleAmount = getLocaleAmount;
exports.getLocaleFromLanguageCode = getLocaleFromLanguageCode;
exports.isVariantLocale = exports.isOrdinalLanguage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

function getLocaleFromLanguageCode(code) {
  switch (code) {
    case 'sv':
      return 'sv-SE';

    case 'es':
      return 'es-ES';

    case 'fi':
      return 'fi-FI';

    case 'no':
      return 'no-NO';

    case 'en':
    default:
      return 'en-UK';
  }
}

function getLocaleAmount(amount, locale, options) {
  var _options = (0, _extends2["default"])({}, options);

  if (_options.currency) {
    _options.style = 'currency';
  } else {
    _options.style = 'decimal';
  }

  var _locale = locale.includes('-') ? locale : getLocaleFromLanguageCode(locale);

  return new Intl.NumberFormat(_locale, _options).format(amount);
}

var getBaseLocale = function getBaseLocale(locale) {
  return locale ? locale.split('-')[0] : locale;
};

exports.getBaseLocale = getBaseLocale;

var getDateLocale = function getDateLocale(locale) {
  switch (getBaseLocale(locale)) {
    case 'en':
      return 'enGB';

    case 'no':
      return 'nb';

    default:
      return locale.split('-')[0];
  }
};

exports.getDateLocale = getDateLocale;

var isOrdinalLanguage = function isOrdinalLanguage(locale) {
  switch (getBaseLocale(locale)) {
    case 'en':
      return true;

    default:
      return false;
  }
};

exports.isOrdinalLanguage = isOrdinalLanguage;

var isVariantLocale = function isVariantLocale(locale) {
  return new RegExp('-x-', 'gi').test(locale);
};

exports.isVariantLocale = isVariantLocale;